module.exports = __webpack_public_path__ + "./images/531a12420bac7c7517fa0d8a34fbcd0c.webp";